<script setup lang="ts"></script>
<template>
  <div class="card-stat-wrapper">
    <slot></slot>
  </div>
</template>
<style lang="scss">
@import 'App.scss';
.card-stat-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin: 1rem 0;
}
</style>
